import React, { useState, useMemo } from 'react';

import useMediaQueries from 'hooks/useMediaQueries';

export enum ContainerType {
    mobile = 'mobile',
    desktop = 'desktop',
}

const ResponsiveContainer = ({
    For,
    defaultVisibility = false,
    children,
    width = 640,
}: {
    For: ContainerType.mobile | ContainerType.desktop;
    defaultVisibility?: boolean;
    children: React.ReactNode;
    width?: number;
}) => {
    const [isVisible, setIsVisible] = useState(defaultVisibility);

    const query = useMemo(
        () => ({
            [`(max-width: ${width}px)`]: () => {
                setIsVisible(For === ContainerType.mobile);
            },
            [`(min-width: ${width}px)`]: () => {
                setIsVisible(For === ContainerType.desktop);
            },
        }),
        [For, width]
    );

    useMediaQueries(query);

    return isVisible ? <>{children}</> : null;
};

export default ResponsiveContainer;
